// extracted by mini-css-extract-plugin
export var bodyRow = "_d8-d";
export var cardColumns = "_d8-e";
export var ellipsesOverflow = "_d8-2";
export var flatBottomCorners = "_d8-3";
export var flatTopCorners = "_d8-4";
export var headerActionsDropdown = "_d8-f";
export var headerBottomRow = "_d8-c";
export var headerTopRow = "_d8-b";
export var orderDetailsWrapper = "_d8-0";
export var orderInfoContainer = "_d8-1";
export var productDetails = "_d8-9";
export var productImage = "_d8-5";
export var responsiveTable = "_d8-8";
export var shipmentContainer = "_d8-a";
export var tableBottomLeft = "_d8-6";
export var tableBottomRight = "_d8-7";
export var trackingLink = "_d8-g";